import {backup} from './backup';
import {shouldUpgrade} from './shouldUpgrade';
import {rewriteDataStructures} from './upgrade';

export function checkCoreDataStructures(): void {
  if (!shouldUpgrade()) return;

  backup();
  rewriteDataStructures();
}
